/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OriginalSpecialityResultModel } from '../../models/original-speciality-result-model';

export interface AnonymousOriginalSpecialitiesGet$Params {
  systemSpecialityGroupId?: string;
  healthCareServiceFhirId?: string;
}

export function anonymousOriginalSpecialitiesGet(http: HttpClient, rootUrl: string, params?: AnonymousOriginalSpecialitiesGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<OriginalSpecialityResultModel>>> {
  const rb = new RequestBuilder(rootUrl, anonymousOriginalSpecialitiesGet.PATH, 'get');
  if (params) {
    rb.query('systemSpecialityGroupId', params.systemSpecialityGroupId, {});
    rb.query('healthCareServiceFhirId', params.healthCareServiceFhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<Array<OriginalSpecialityResultModel>>;
    })
  );
}

anonymousOriginalSpecialitiesGet.PATH = '/Anonymous/OriginalSpecialities';
